var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { commonCssStyles } from "../../global-styles.js";
import { msg } from "@lit/localize";
/**
 * @see https://lit.dev/docs/components/overview/
 * @see https://lit.dev/docs/tools/publishing/#self-define-elements
 */
let MobileMenuButton = class MobileMenuButton extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
    }
    focus(options) {
        this.shadowRoot.getElementById("menu-button").focus(options);
    }
    // Render the UI as a function of component state
    render() {
        return html `
      <button
        id="menu-button"
        class="container ${classMap({ open: this.open })}"
        aria-label="${msg("Navigation menu")}"
      >
        <div class="burger" aria-hidden="${this.open}">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="close" clip-path="url(#clip0_7017_264)">
              <rect
                id="line 1"
                x="2"
                y="3"
                width="20"
                height="2"
                rx="1"
                fill="#343434"
              />
              <rect
                id="line 2"
                x="2"
                y="11"
                width="20"
                height="2"
                rx="1"
                fill="#343434"
              />
              <rect
                id="line 3"
                x="2"
                y="19"
                width="20"
                height="2"
                rx="1"
                fill="#343434"
              />
            </g>
            <defs>
              <clipPath id="clip0_7017_264">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="times" aria-hidden="${!this.open}">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="close" clip-path="url(#clip0_7017_1190)">
              <rect
                id="line 1"
                x="20.9997"
                y="4.80019"
                width="22.9096"
                height="2"
                rx="1"
                transform="rotate(135 20.9997 4.80019)"
                fill="#343434"
              />
              <rect
                id="line 2"
                x="4.80029"
                y="3.00027"
                width="22.9096"
                height="2"
                rx="1"
                transform="rotate(45 4.80029 3.00027)"
                fill="#343434"
              />
              <rect
                id="line 3"
                x="4.80029"
                y="3.00027"
                width="22.9096"
                height="2"
                rx="1"
                transform="rotate(45 4.80029 3.00027)"
                fill="#343434"
              />
            </g>
            <defs>
              <clipPath id="clip0_7017_1190">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </button>
    `;
    }
};
// Define scoped styles right with your component, in plain CSS
// noinspection CssUnresolvedCustomProperty
MobileMenuButton.styles = [
    commonCssStyles,
    css `
      .container {
        width: 24px;
        height: 24px;
        cursor: pointer;
        position: relative;
        display: flex;
        border: none;
        border-radius: 4px;
        padding: 0;
        background: none;
      }

      .container div {
        position: absolute;
        transition: var(--delay-transition75);
      }

      .container.open .times {
        width: 24px;
        height: 24px;
        opacity: 1;
      }

      .container.open .burger {
        width: 0;
        opacity: 0;
      }

      .container:not(.open) .burger {
        width: 24px;
        height: 24px;
        opacity: 1;
      }

      .container:not(.open) .times {
        width: 0;
        opacity: 0;
      }

      .container:focus-visible {
        outline: 2px solid var(--tones-lavender50-color);
        outline-offset: 6px;
      }
    `,
];
__decorate([
    property({ type: Boolean, reflect: true })
], MobileMenuButton.prototype, "open", void 0);
MobileMenuButton = __decorate([
    customElement("mobile-menu-button")
], MobileMenuButton);
export { MobileMenuButton };
